import Lenis from '@studio-freight/lenis';

export class LenisSmooth {
	constructor( lerp = 0.06 ) {
		this.lerp = lerp;
		this.init();
	}

	init() {
		const lenis = new Lenis( {
			lerp: this.lerp,
			smooth: true,
		} );

		const loop = ( time ) => {
			lenis.raf( time );
			window.requestAnimationFrame( loop );
		};

		window.requestAnimationFrame( loop );
	}
}
